/**
 * Canonical origin for SEO (Open Graph, JSON-LD, sitemap-style links).
 * Set REACT_APP_SITE_ORIGIN in production (e.g. https://kanplays.com) so
 * previews and canonical URLs stay correct behind proxies or staging hosts.
 */
export function getPublicSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_SITE_ORIGIN?.trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined") return window.location.origin;
  return "";
}

export function absoluteUrl(path: string): string {
  const origin = getPublicSiteOrigin();
  const p = path.startsWith("/") ? path : `/${path}`;
  return origin ? `${origin}${p}` : p;
}
